module.exports = __webpack_public_path__ + "static/media/dummyprofpic.4dcb5ab4.png";